import Vue from 'vue';

const state = {
    qualifications: {
        option: '',
        amount: 0,
    },

    totalIncome: 0,

    turnover: {
        today: 0,
        lastWeek: 0,
        monthly: 0,
    },
};

const getters = {
    bonusIncome: state => {
        return state.bonusIncome;
    },

    income: state => {
        return state.income;
    },

    qualifications: state => {
        return state.qualifications;
    },

    totalIncome: state => {
        return state.totalIncome;
    },

    turnover: state => {
        return state.turnover;
    }
};

const mutations = {
    /**
     * Set qualifications in store
     * @param state
     * @param data
     */
    setQualifications (state, data) {
        let amount = data.turnover ? data.turnover.amount : '',
            currency = data.turnover ? data.turnover.currency.code : '';
        Vue.set(state, 'qualifications', {
            option: data.option,
            amount: amount + ' ' + currency
        });
    },

    /**
     * Set total income in store
     * @param state
     * @param data
     */
    setTotalIncome (state, data) {
        Vue.set(state, 'totalIncome', data);
    }
};

export default {
    state,
    getters,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/mlm.js